import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import fetchAPI from "../../../common/fetchAPI";
import { RolePermissionStateClass } from "./interfaces/RolePermissionStateClass";
import { RootState } from "../../../app/store";

const initialState: RolePermissionStateClass = {
    isLoading: false,
    rolePermissionList: [],
    status: "idle",
    selectedRecord: {},
    isReload: false,
    rolePermissionReadOnlyList:[],
    isFirstReload:true,
};


interface IThunkApi {
    state: {
        rolePermission: RolePermissionStateClass
    }
}


export const getSystemSecurityCategoryPageViewAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        "PagePermission/v2/getSystemSecurityCategoryPageView",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/v2/PagePermission", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = await response.json();
            return json;
        }
    )
export const getDataForDefaultPageDropDown = createAsyncThunk
    <any, any, IThunkApi>
    (
        "PagePermission/v2/getDataForDefaultPageDropDown",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/v2/PagePermission/DefaultPageDropDown", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = await response.json();
            return json;
        }
    )
    
export const updatePermissionsAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'PagePermission/v2/updatePermissions',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/PagePermission/UpdatePermissions', 'POST', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )

export const updateDefaultAccountPageAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'PagePermission/v2/updateDefaultAccountPage',
        async (arg, thunkApi) => {
     
            const { AccountRoleId, DefaultAccountPageId } = arg;
            const response = await fetchAPI('api/v2/PagePermission/UpdateDefaultAccountPage/' + AccountRoleId +'/'+ DefaultAccountPageId, 'PUT', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )
export const deleteAccountStatusAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Status/v2/deleteAccountStatus",
        async (arg, thunkApi) => {
     
            const response = await fetchAPI("api/v2/Status/" + arg, "Delete", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = await response.json();
            return json;
        }
    )
export const DeleteSelectedAccountStatusAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Status/v2/DeleteSelectedAccountStatus",
        async (arg, thunkApi) => {
     
            const response = await fetchAPI('api/v2/Status/DeleteSelected/', 'Delete', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;

        }
    )
export const rolePermissionSlice = createSlice({
    name: "RolePermission",
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {}
        },
        UpdateRolePermissionStates: (state, action) => {
            console.log('UpdateRolePermissionStates');
            const {SystemSecurityCategoryPageId,FieldName,ValueToUpdate } = action.payload;
            const currentindex = state.rolePermissionList.findIndex((item) => item.SystemSecurityCategoryPageId == SystemSecurityCategoryPageId);
            const newArray = [...state.rolePermissionList];
            newArray[currentindex] = { ...newArray[currentindex], [FieldName]: ValueToUpdate };
            state.rolePermissionList = newArray;
        },
        checkedIsReloadState: (state, action) => {
            console.log('checkedIsReloadState');
           
            state.rolePermissionList = [];
           
            state.isReload = true;
           
        },
        
    },
    extraReducers: (builder) => {
        builder
            .addCase(getSystemSecurityCategoryPageViewAsync.pending, (state) => {
                state.status = "loading";
                state.isLoading = true;
            })
            .addCase(getSystemSecurityCategoryPageViewAsync.fulfilled, (state, { payload }) => {
                console.log('getSystemSecurityCategoryPageViewAsync', payload)
                state.status = "idle";
                 
                if (Object.keys(payload.Data).length === 0) {
                    
                    state.rolePermissionList = [];
                } else {
                    state.rolePermissionList = payload.Data;
                    state.rolePermissionReadOnlyList = payload.Data;
                    state.isLoading = false;

                }

                state.isReload = false;
                state.selectedRecord = {};
            })
            .addCase(getSystemSecurityCategoryPageViewAsync.rejected, (state) => {
                state.status = "failed";
                state.isLoading = false;

            })



            .addCase(getDataForDefaultPageDropDown.pending, (state) => {
                state.status = "loading";
                state.isLoading = true;
            })
            .addCase(getDataForDefaultPageDropDown.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                
                if (Object.keys(payload.Data).length === 0) {
                    state.selectedRecord = {};
                }
                else {
                    state.selectedRecord = payload.Data[0];
                }
                state.isLoading = false;
            })
            .addCase(getDataForDefaultPageDropDown.rejected, (state) => {
                state.status = "failed";
                state.isLoading = false;

            })

            ///
            .addCase(updatePermissionsAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(updatePermissionsAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
                
            })
            .addCase(updatePermissionsAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })

            .addCase(updateDefaultAccountPageAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(updateDefaultAccountPageAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
            })
            .addCase(updateDefaultAccountPageAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })

            .addCase(deleteAccountStatusAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(deleteAccountStatusAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(deleteAccountStatusAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })

            .addCase(DeleteSelectedAccountStatusAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(DeleteSelectedAccountStatusAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(DeleteSelectedAccountStatusAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })



    }
})

export const { resetSelectedRecordObjectInState,UpdateRolePermissionStates,checkedIsReloadState } = rolePermissionSlice.actions
export const rolePermissionState = (state: RootState) => state.rolePermission
export default rolePermissionSlice.reducer